import { render, staticRenderFns } from "./AudienceDeleteModal.vue?vue&type=template&id=9616b49a"
import script from "./AudienceDeleteModal.vue?vue&type=script&lang=js"
export * from "./AudienceDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports